import qs from 'qs';
import _pt from '~/assets/js/app-node';
import axiosSupply from './axios.supply';
import { Loading } from 'element-ui';
/**
 * 获取setcookie中有效值
 * @param  {String/array} obj set-cookie值
 * @return {string}     抓取到的set-cookie有效值
 */
function getShiro(obj) {
    var cookieAdd = '',
        switchObj = {
        string: function() {
            cookieAdd = _pt.getCookieByName('shiroSessionId', obj);
        },
        array: function() {
            obj.forEach(item => {
                cookieAdd = (_pt.getCookieByName('shiroSessionId', obj) || cookieAdd);
            });
        },
        undefined: function() {}
    };
    switchObj[_pt.getType(obj)]();

    return cookieAdd;
};
 let loadingInstance = '';  //加载提示
// let whiteList=['wechat/openID','/pay/result.json']
let blackList=[
    '/web/bbs/comment/form.json',
    '/web/bbs/comment/delete.json',
    '/web/bbs/liked/on.json',
    '/web/bbs/liked/off.json',
    'share/on.json'
]
export default function (context)  {
    var app = context.app;

    axiosSupply.mixin(app.$axios, app);

    app.$axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
    app.$axios.defaults.withCredentials = true;

    //request拦截器
    app.$axios.interceptors.request.use(config => {
        let queryUrl = config.url.indexOf('?') > -1 ? config.url.substring(0, config.url.indexOf('?')) : config.url
         if(blackList.indexOf(queryUrl)!=-1){
             // 拦截评论的回答 点赞 删除 的接口请求 添加加载标识
            if (loadingInstance) loadingInstance.close()
            // 禁止加载框标识
            if(!config.cannelLoading) {
                loadingInstance = Loading.service({
                    text: '加载中...',
                    target: config.loadingDom
                })
            }
        }
        return new Promise((resolve) => {
            config.url += (/\?/.test(config.url) ? `&ts=${new Date().getTime()}` : `?ts=${new Date().getTime()}`);

            resolve(config);
        });
	}, function (error) {
        // 对请求错误做些什么
        return Promise.reject(error);
    });

	// response拦截器
	app.$axios.interceptors.response.use(({data, config, headers}) => {
        if (loadingInstance) loadingInstance.close();  //关闭加载提示
        return axiosSupply.resInterceptors(data, config, headers, context);
	});
}
